import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { document } from '../../../helpers/BrowserHelpers';

var getDisplayName = function getDisplayName(WrappedComponent) {
  var component = WrappedComponent.WrappedComponent || WrappedComponent;
  return component.displayName || component.name || 'Component';
};

export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$getNodeWidth = _ref.getNodeWidth,
      getNodeWidth = _ref$getNodeWidth === void 0 ? function (props) {
    return undefined;
  } : _ref$getNodeWidth;

  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inherits(BlockResizeableDecorator, _Component);

      function BlockResizeableDecorator() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, BlockResizeableDecorator);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BlockResizeableDecorator)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "state", {
          hoverPosition: {
            isLeft: false,
            isRight: false,
            canResize: false
          },
          clicked: false,
          width: undefined
        });

        _defineProperty(_assertThisInitialized(_this), "setNodeData", function (data) {
          _this.props.onResize(_this.props.editor, _this.props.node, data);
        });

        _defineProperty(_assertThisInitialized(_this), "mouseLeave", function () {
          if (!_this.state.clicked) {
            _this.setState({
              hoverPosition: {}
            });
          }
        });

        _defineProperty(_assertThisInitialized(_this), "mouseMove", function (evt) {
          var tolerance = 10;
          var hoverPosition = _this.state.hoverPosition; // eslint-disable-next-line react/no-find-dom-node

          var pane = ReactDOM.findDOMNode(_assertThisInitialized(_this));
          var b = pane.getBoundingClientRect();
          var x = evt.clientX - b.left;
          var isLeft = x < tolerance;
          var isRight = x >= b.width - tolerance;
          var canResize = isLeft || isRight;
          var newHoverPosition = {
            isLeft: isLeft,
            isRight: isRight,
            canResize: canResize
          };
          var hasNewHoverPositions = Object.keys(newHoverPosition).filter(function (key) {
            return hoverPosition[key] !== newHoverPosition[key];
          });

          if (hasNewHoverPositions.length) {
            _this.setState({
              hoverPosition: newHoverPosition
            });
          }
        });

        _defineProperty(_assertThisInitialized(_this), "mouseDown", function (event) {
          // No mouse-hover-position data? Nothing to resize!
          if (!_this.state.hoverPosition.canResize) {
            return;
          }

          event.preventDefault();
          var editor = _this.props.editor;
          var hoverPosition = _this.state.hoverPosition;
          var isLeft = hoverPosition.isLeft,
              isRight = hoverPosition.isRight; // TODO figure out how to achieve this without fetching the DOM node
          // eslint-disable-next-line react/no-find-dom-node

          var pane = ReactDOM.findDOMNode(_assertThisInitialized(_this));
          var startX = event.clientX;
          var startWidth = parseInt(document.defaultView.getComputedStyle(pane).width, 10); // Do the actual drag operation

          var doDrag = function doDrag(dragEvent) {
            var width = startWidth + (isLeft ? startX - dragEvent.clientX : dragEvent.clientX - startX);
            var editorNode = editor.el;
            width = Math.min(editorNode.clientWidth, width);
            var newState = {};

            if (isLeft || isRight) {
              newState.width = width;
            }

            dragEvent.preventDefault();

            _this.setState(newState);
          }; // Finished dragging


          var stopDrag = function stopDrag() {
            // TODO clean up event listeners
            document.removeEventListener('mousemove', doDrag, false);
            document.removeEventListener('mouseup', stopDrag, false);
            var width = _this.state.width;

            _this.setState({
              clicked: false
            });

            _this.setNodeData({
              width: width
            });
          }; // TODO clean up event listeners


          document.addEventListener('mousemove', doDrag, false);
          document.addEventListener('mouseup', stopDrag, false);

          _this.setState({
            clicked: true
          });
        });

        return _this;
      }

      _createClass(BlockResizeableDecorator, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          var _this$props = this.props,
              editor = _this$props.editor,
              style = _this$props.style,
              node = _this$props.node,
              resizable = _this$props.resizable,
              elementProps = _objectWithoutProperties(_this$props, ["editor", "style", "node", "resizable"]);

          var _this$state = this.state,
              width = _this$state.width,
              hoverPosition = _this$state.hoverPosition;
          var isLeft = hoverPosition.isLeft,
              isRight = hoverPosition.isRight;

          var styles = _objectSpread({
            position: 'relative'
          }, style);

          styles.width = width || getNodeWidth(node) || 240; // Handle cursor

          if (isRight || isLeft) {
            styles.cursor = 'ew-resize';
          } else {
            styles.cursor = 'default';
          }

          var resizableAttributes = editor.readOnly || !resizable ? {} : {
            onMouseDown: this.mouseDown,
            onMouseMove: this.mouseMove,
            onMouseLeave: this.mouseLeave
          };
          return React.createElement(WrappedComponent, Object.assign({}, elementProps, {
            resizableAttributes: resizableAttributes,
            editor: editor,
            node: node,
            ref: function ref(element) {
              _this2.wrapper = element;
            },
            style: styles
          }));
        }
      }]);

      return BlockResizeableDecorator;
    }(Component), _defineProperty(_class, "displayName", "BlockResizeable(".concat(getDisplayName(WrappedComponent), ")")), _defineProperty(_class, "WrappedComponent", WrappedComponent.WrappedComponent || WrappedComponent), _temp;
  };
});